import { SubjectTypes } from '../../../../types/RiskAnalaysis';

export const subjectsByCountry = {
  NL: [
    SubjectTypes.MOBILITY,
    SubjectTypes.HOME_AND_FAMILY,
    SubjectTypes.TRAVEL_AND_LEISURE,
  ],
  BE: [
    SubjectTypes.MOBILITY,
    SubjectTypes.HOME_AND_FAMILY,
    SubjectTypes.HEALTH,
    SubjectTypes.LEGAL,
    SubjectTypes.HOBBIES_AND_INTERESTS,
    SubjectTypes.LIFE_AND_FUTURE,
  ],
};
